var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgStandardShipping(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0H32V32H0z"
  }), /*#__PURE__*/React.createElement("g", {
    fill: "#FFF",
    stroke: "#212121",
    strokeWidth: 1.5,
    transform: "translate(4.667 8.667)"
  }, /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M0 0H14.667V13.333H0zM14.667 3.333L21.228 3.333 23.333 7.333 23.333 13.333 14.667 13.333z"
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 5.333,
    cy: 13.333,
    r: 2
  }), /*#__PURE__*/React.createElement("circle", {
    cx: 19,
    cy: 13.333,
    r: 2
  }), /*#__PURE__*/React.createElement("path", {
    strokeLinejoin: "round",
    d: "M14.667 3.333L21.333 3.333 23.333 7.333 14.667 7.333z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgStandardShipping);
export default __webpack_public_path__ + "static/media/standard-shipping.d71e3c3b0ffce8f0fae5091825c0d799.svg";
export { ForwardRef as ReactComponent };